import { STATUS, scoreTone, daysText } from "./complianceUtils";

export const StatusBadge = ({ status, testid, small }) => {
  const s = STATUS[status] || STATUS.missing;
  return <span className={`inline-flex items-center gap-1.5 rounded-md border px-2 ${small ? "py-0 text-[10px]" : "py-0.5 text-[11px]"} font-medium ${s.cls}`} data-testid={testid}><span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />{s.label}</span>;
};

export const DaysChip = ({ r, testid }) => {
  const t = daysText(r);
  if (!t) return null;
  return <span className={`text-[11px] ${r.status === "expired" ? "text-red-600 font-semibold" : r.status === "expiring" ? "text-amber-600" : "text-muted-foreground"}`} data-testid={testid}>{t}</span>;
};

export const ScoreRing = ({ score, size = 56, testid }) => {
  const r = (size - 8) / 2, c = 2 * Math.PI * r, pct = score ?? 0;
  const tone = score === null || score === undefined ? "#9ca3af" : score >= 90 ? "#059669" : score >= 60 ? "#d97706" : "#dc2626";
  return (
    <div className="relative shrink-0" style={{ width: size, height: size }} data-testid={testid}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} stroke="currentColor" strokeWidth="6" fill="none" className="text-muted/60" />
        <circle cx={size / 2} cy={size / 2} r={r} stroke={tone} strokeWidth="6" fill="none" strokeLinecap="round" strokeDasharray={c} strokeDashoffset={c - (c * pct) / 100} style={{ transition: "stroke-dashoffset .6s ease" }} />
      </svg>
      <span className={`absolute inset-0 flex items-center justify-center text-xs font-bold ${scoreTone(score)}`}>{score === null || score === undefined ? "—" : `${score}%`}</span>
    </div>
  );
};

export const StatusCounts = ({ roll, testid }) => (
  <div className="flex flex-wrap gap-1.5" data-testid={testid}>
    {["expired", "expiring", "valid", "missing"].map((k) => roll[k] > 0 && (
      <span key={k} className={`inline-flex items-center gap-1 rounded-md border px-1.5 py-0.5 text-[11px] font-medium ${STATUS[k].cls}`}><span className={`h-1.5 w-1.5 rounded-full ${STATUS[k].dot}`} />{roll[k]} {STATUS[k].label.toLowerCase()}</span>
    ))}
    {roll.total === 0 && <span className="text-[11px] text-muted-foreground">Not set up</span>}
  </div>
);
